import * as React from 'react';
import './footerPage.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import pay from "../../../asset/images/image 7.jpg";
import pay1 from "../../../asset/images/image 8.png";
import download from "../../../asset/images/image 9.png";
import download1 from "../../../asset/images/image 10.png";
import Bocongthuong from "../../../asset/images/bocongthuong.png";
import EnvironMent from "../../../asset/images/Environment.png";
import Phone from "../../../asset/images/phone.png";
import Email from "../../../asset/images/mail.png";
import { useSelector } from 'react-redux';
const FooterPage = () => {
  const listInformation = useSelector((state)=>state.information.data);
  const handleGoogleMapsClick = () => {
    const googleMapsURL = "https://maps.app.goo.gl/bY8U5mBzNQf9pR8a8";
    window.open(googleMapsURL, "_blank");
  };
  const hotiline = listInformation && listInformation?.map(item=> item.site_hotline);
  const handleClickCall =()=>{
    const telLink = `tel:${hotiline}`;
    window.open(telLink, '_blank');
  }
  return (
    <>
      <div className="containerFooterMobile">
        {
       listInformation && listInformation?.map((item, index) => (
            <div
              className="waper waperMobile"
              key={index}
            >
              <div className="footerWapper">
                <div className="footerContact">
                  <div className="footerLogo">
                    <img alt="/" src={item?.site_logo2_url} />
                  </div>
                  <p>Chuyển đổi số thành công!</p>
                  <ul
                    className="contactContent contactContentMobile"
                  >
                    <li
                      className="contactContentText contactContentTextMobile"
                      onClick={handleGoogleMapsClick}
                    >
                      <img alt='/' src={EnvironMent}/>
                      <a href={item?.site_footer_address}>{item?.site_footer_address}</a>
                    </li>
                    <li className="nation nationMobile">
                      Việt Nam
                    </li>
                    <li
                      className="contactContentText contactContentTextMobile"
                      onClick={handleClickCall}
                    >
                      <img alt='/' src={Phone}/>
                      <a href={item?.site_footer_phone}>{item?.site_footer_phone}</a>
                    </li>
                    <li
                      className="contactContentText contactContentTextMobile"
                    >
                      <img alt='/' src={Email}/>
                      <a href={item?.site_footer_email}>{item?.site_footer_email}</a>
                    </li>
                  </ul>
                </div>
                <div
                  className="footerContacts footerContactsProduct"
                >
                  <div className="footerTitle">
                    <p>Sản phẩm</p>
                  </div>

                  <ul className="contentText">
                    <li> <a href='#'>Hệ thống</a> </li>
                    <li> <a href='#'> Quảng cáo</a> </li>
                    <li> <a href='#'> Ứng dụng</a> </li>
                    <li> <a href='#'> Dữ liệu</a> </li>
                    <li> <a href='#'>Quản lý</a></li>
                  </ul>
                </div>
                <div className="aboutUs">
                  <div className="footerTitle">
                    <p>Về chúng tôi</p>
                  </div>
                  <ul className="contentText">
                    <li> <a href='#'>Giới thiệu CarLink</a> </li>
                    <li> <a href='#'> Phần mềm nhà xe/đại lý </a></li>
                    <li> <a href='#'>Tuyển dụng</a></li>
                    <li> <a href='#'>Tin tức</a></li>
                  </ul>
                </div>
                <div className="footerPaypay">
                  <div
                    className="footerTitle footerTitleMobile"
                  >
                    <div className="navbarTititleFooter">
                      <p>Cổng thanh toán</p>
                      <div className="lineBottom"> </div>
                    </div>
                    <div className="footerWapperImage">
                      <div
                        className="footerPay footerPayMobile"
                      >
                        <img alt='' src={pay} />
                      </div>
                      <div className="footerPay1">
                        <img alt='' src={pay1} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="footerContacts">
                  <div
                    className="footerTitle footerTitleMobile"
                  >
                    <div className="navbarTititleFooter">
                      <p>Tải xuống</p>
                      <div className="lineBottom"> </div>
                    </div>
                    <div className="footerWapperImage">
                      <div>  
                        <a href={item.play_store_url}>
                          <img alt='' src={download} />                   
                        </a>             
                      </div>
                      <div> 
                        <a href={item.app_store_url}>
                          <img alt='' src={download1} />              
                        </a>               
                      </div>
                    </div>
                    <div className="footerImageMobileMore">
                        <img alt='' src={Bocongthuong} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="waperLine">
                <hr className="liness" />
              </div>
              <div
                className="navbarLink navbarLinkMobile"
              >
                <div
                  className="coppyRight coppyRightMobile"
                >
                  <span>{item.site_footer_version}</span>
                </div>
                <div
                  className="socialNetwork socialNetworkMobile"
                >
                  <div
                    className="netWorkIcon netWorkIconMobile"
                  >
                    <div className="iconNetWork">
                      <a
                        className="iconLink iconLinkMobile"
                        href={item.site_footer_social_url1}
                      >
                        <FontAwesomeIcon  icon={faFacebookF} />
                      </a>
                    </div>
                    <div className="iconNetWork">
                      <a
                        className="iconLink iconLinkMobile"
                        href={item.site_footer_social_url2}
                      >
                        <FontAwesomeIcon icon={faXTwitter} /> 
                      </a>
                    </div>
                    <div className="iconNetWork"
                    >
                      <a
                        className="iconLink iconLinkMobile"

                        href={item.site_footer_social_url3}
                      >
                        <FontAwesomeIcon icon={faInstagram} />
                      </a>
                    </div>
                  </div>
                  <div className="support supportMobile">
                    <span>Hỗ trợ</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};
export default FooterPage;
